import { render, staticRenderFns } from "./OrderNum.vue?vue&type=template&id=1f9c147e&scoped=true&"
import script from "./OrderNum.vue?vue&type=script&lang=js&"
export * from "./OrderNum.vue?vue&type=script&lang=js&"
import style0 from "./OrderNum.vue?vue&type=style&index=0&id=1f9c147e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9c147e",
  null
  
)

export default component.exports